import script from "./Signup.vue?vue&type=script&setup=true&lang=ts"
export * from "./Signup.vue?vue&type=script&setup=true&lang=ts"

import "./Signup.vue?vue&type=style&index=0&id=8719482a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8719482a"]])

export default __exports__